import { nmaApi } from '../index'

export const fetchWinners = () => {
  return nmaApi.get('networked-awards/files/2025?winner=1')
}
